import styled from 'styled-components';

import Button from '../../../../CoreWrappers/Button';

export default styled(Button)`
	align-self: start;
	&.motif-button.motif-text-alt-button {
		.motif-icon svg {
			color: var(--orange-200);
		}
	}
`;
